import { render, staticRenderFns } from "./Align.vue?vue&type=template&id=2a3a9fa2&scoped=true"
import script from "./Align.vue?vue&type=script&lang=js"
export * from "./Align.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a9fa2",
  null
  
)

export default component.exports